import { AtCheckbox, AtText } from '@/components/atoms';
import { ICheckboxInputProps } from './types';

export const FloorplanOptions = ({
  checkboxConfigs,
  filterValues,
  setFilter,
  setWereFiltersUsed,
}: ICheckboxInputProps) => {
  return (
    <div className="mt-7 flex flex-col gap-5 md:mt-12 md:flex-row">
      {checkboxConfigs.map(({ key, label }) => (
        <AtCheckbox
          key={key}
          onChange={(checked: boolean) => {
            setFilter(key, checked);
            setWereFiltersUsed(true);
          }}
          value={filterValues[key] as string}
          checked={(!!filterValues[key] as boolean) || false}
        >
          <AtText size="sm" type="span">
            {label}
          </AtText>
        </AtCheckbox>
      ))}
    </div>
  );
};
